import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 10C4 8.89543 4.89543 8 6 8H18C19.1046 8 20 8.89543 20 10V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V10ZM18 10H6V20H18V10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16.5C10 15.3954 10.8954 14.5 12 14.5C13.1046 14.5 14 15.3954 14 16.5C14 17.6046 13.1046 18.5 12 18.5C10.8954 18.5 10 17.6046 10 16.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 17.5C11.4477 17.5 11 17.0523 11 16.5L11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13V16.5C13 17.0523 12.5523 17.5 12 17.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.8232 3.10915C9.60569 2.41953 10.6566 2 12 2C13.3434 2 14.3943 2.41953 15.1768 3.10915C15.9402 3.78194 16.3785 4.64962 16.633 5.44534C16.8882 6.2431 16.9766 7.02367 17.0041 7.59242C17.0179 7.87986 17.0166 8.12087 17.0115 8.293C17.009 8.37923 17.0055 8.44865 17.0025 8.4985C17.001 8.52344 16.9996 8.54353 16.9985 8.55841L16.9971 8.57682L16.9966 8.58303L16.9964 8.58537C16.9963 8.58581 16.9962 8.5872 16 8.5C15.0038 8.4128 15.0038 8.41317 15.0038 8.41352L15.0036 8.41497L15.004 8.41003L15.0062 8.37797C15.008 8.34725 15.0105 8.29851 15.0124 8.23435C15.0162 8.10569 15.0174 7.91701 15.0064 7.68883C14.9841 7.22633 14.9128 6.63191 14.7281 6.05466C14.5428 5.47538 14.2612 4.96806 13.8545 4.6096C13.4668 4.26797 12.8974 4 12 4C11.1026 4 10.5332 4.26797 10.1456 4.6096C9.73882 4.96806 9.4572 5.47537 9.27191 6.05466C9.08728 6.6319 9.01596 7.22633 8.99364 7.68883C8.98263 7.91701 8.98387 8.10568 8.98765 8.23434C8.98953 8.2985 8.99203 8.34724 8.99388 8.37796L8.99601 8.41003L8.99627 8.41351C8.99624 8.41316 8.9962 8.41279 8.00001 8.5C7.00382 8.58721 7.00379 8.5868 7.00375 8.58636L7.00347 8.58304L7.00295 8.57683L7.00153 8.55842C7.00042 8.54353 6.99902 8.52345 6.99752 8.49851C6.99451 8.44865 6.99104 8.37923 6.98851 8.293C6.98346 8.12088 6.98209 7.87987 6.99597 7.59242C7.02341 7.02367 7.11182 6.2431 7.36699 5.44534C7.62151 4.64963 8.0598 3.78194 8.8232 3.10915Z",
			fill: "currentColor"
		})
	]
});
export default SvgLock;
